import { motion } from "framer-motion";

export const MatchupBanner = ({ homeTeam, awayTeam }) => {
  if (!homeTeam?.name || !awayTeam?.name) return null;

  const homeColor = homeTeam.color || "#DC2626";
  const awayColor = awayTeam.color || "#2563EB";

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="relative overflow-hidden"
      data-testid="matchup-banner"
    >
      {/* Gradient Background - Home on left, Away on right */}
      <div
        className="absolute inset-0"
        style={{
          background: `linear-gradient(90deg, ${homeColor} 0%, ${homeColor}99 25%, #111111 50%, ${awayColor}99 75%, ${awayColor} 100%)`,
        }}
      />
      
      {/* Content */}
      <div className="relative z-10 flex items-center justify-between px-4 md:px-8 py-4 md:py-6">
        {/* Home Team (Left) */}
        <div className="flex items-center gap-3 md:gap-6 flex-1">
          {homeTeam.logo_url ? (
            <img
              src={homeTeam.logo_url}
              alt={homeTeam.name}
              className="w-12 h-12 md:w-16 md:h-16 object-contain drop-shadow-lg"
              data-testid="home-team-logo"
            />
          ) : (
            <div
              className="w-12 h-12 md:w-16 md:h-16 rounded-full flex items-center justify-center text-white font-bold text-xl md:text-2xl shadow-lg"
              style={{ backgroundColor: homeColor }}
              data-testid="home-team-placeholder"
            >
              {homeTeam.name?.charAt(0) || "H"}
            </div>
          )}
          <div className="text-left">
            <div className="text-[10px] md:text-xs font-bold uppercase tracking-widest text-white/60 mb-1">
              Home
            </div>
            <h3 className="font-secondary text-lg md:text-2xl font-black uppercase text-white drop-shadow-md" data-testid="home-team-name">
              {homeTeam.name}
            </h3>
            {homeTeam.mascot && (
              <div className="text-xs md:text-sm text-white/80">{homeTeam.mascot}</div>
            )}
          </div>
        </div>

        {/* VS Divider */}
        <div className="flex flex-col items-center px-4 md:px-8">
          <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-black/50 backdrop-blur-sm flex items-center justify-center border-2 border-white/20">
            <span className="font-secondary text-lg md:text-xl font-black text-white">VS</span>
          </div>
        </div>

        {/* Away Team (Right) */}
        <div className="flex items-center gap-3 md:gap-6 flex-1 justify-end">
          <div className="text-right">
            <div className="text-[10px] md:text-xs font-bold uppercase tracking-widest text-white/60 mb-1">
              Away
            </div>
            <h3 className="font-secondary text-lg md:text-2xl font-black uppercase text-white drop-shadow-md" data-testid="away-team-name">
              {awayTeam.name}
            </h3>
            {awayTeam.mascot && (
              <div className="text-xs md:text-sm text-white/80">{awayTeam.mascot}</div>
            )}
          </div>
          {awayTeam.logo_url ? (
            <img
              src={awayTeam.logo_url}
              alt={awayTeam.name}
              className="w-12 h-12 md:w-16 md:h-16 object-contain drop-shadow-lg"
              data-testid="away-team-logo"
            />
          ) : (
            <div
              className="w-12 h-12 md:w-16 md:h-16 rounded-full flex items-center justify-center text-white font-bold text-xl md:text-2xl shadow-lg"
              style={{ backgroundColor: awayColor }}
              data-testid="away-team-placeholder"
            >
              {awayTeam.name?.charAt(0) || "A"}
            </div>
          )}
        </div>
      </div>
      
      {/* Bottom accent line */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-white/20 via-white/50 to-white/20" />
    </motion.div>
  );
};

export default MatchupBanner;
